import React, { useEffect, useState } from 'react'
import { titleData } from '../../../data/titles'
import { InputFieldText, FieldGroup, Field, SubmitButton, FormCard, InputFieldDate } from '../../reusable'
import { FormPartInterface, SaveValueInterface } from '../../../interfaces'
import globalStyles from '../../../globals/pages.module.scss'

export const Person = (props: FormPartInterface & { populateData?: any }) => {
    const { saveValueFunct, isActive, assignGroup, populateData } = props
    const [currentStep, setCurrentStep] = useState(0)
    const [postCurrentStep, setPostCurrentStep] = useState(0)
    const [stepData, setStepData] = useState<any>({})
    const [formErrors, setFormErrors] = useState<{ [key: string]: boolean }>({})
    const [showErrors, setShowErrors] = useState(false)
    const [isFormValid, setIsFormValid] = useState(false)

    // console.log('PERSON DATA:' + JSON.stringify(stepData))

    useEffect(() => {
        if (populateData) {
            setStepData({
                title: populateData.title || '',
                firstname: populateData.firstname || '',
                lastname: populateData.lastname || '',
                dob: populateData.dob || '',
            })
        }
    }, [populateData])

    useEffect(() => {
        validateForm(true)
    }, [stepData])

    const validateForm = (updateState = false) => {
        const newErrors: { [key: string]: boolean } = {}
        let hasErrors = false

        if (!stepData.title?.trim()) {
            newErrors.title = true
            hasErrors = true
        }
        if (!stepData.firstname?.trim()) {
            newErrors.firstname = true
            hasErrors = true
        }
        if (!stepData.lastname?.trim()) {
            newErrors.lastname = true
            hasErrors = true
        }
        if (!stepData.dob?.trim()) {
            newErrors.dob = true
            hasErrors = true
        }

        if (updateState) {
            setFormErrors(newErrors)
            setIsFormValid(!hasErrors)
        }
        return !hasErrors
    }

    const preSaveValueFunct = (dataToSave: SaveValueInterface) => {
        const saved = saveValueFunct(dataToSave)
        setStepData((prevData: any) => ({
            ...prevData,
            [dataToSave.field]: dataToSave.value,
        }))

        if (dataToSave.value.trim()) {
            setFormErrors((prev) => ({
                ...prev,
                [dataToSave.field]: false,
            }))
        }
        return saved
    }

    const handleNext = () => {
        setShowErrors(true)
        if (!validateForm()) {
            return
        }

        Object.keys(stepData).forEach((field) => {
            saveValueFunct({ field, value: stepData[field] })
        })

        setTimeout(() => {
            assignGroup('contact')
        }, 400)
    }

    return isActive === 'person' ? (
        <FieldGroup title="Contact Information">
            <FormCard assignPostStep={setPostCurrentStep} step={currentStep}>
                <h3>Who's Making a Claim?</h3>
                <p>Please enter your name and date of birth so we can associate all your car finance claims.</p>
                <Field fieldLabel="Title" labelPosition="left" enhanced={true} extraStyle={{ margin: '0 0 20px' }}>
                    <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                        {['Mr', 'Mrs', 'Miss', 'Ms'].map((t) => {
                            const selected = stepData.title === t
                            return (
                                <button
                                    key={t}
                                    type="button"
                                    onClick={() => preSaveValueFunct({ field: 'title', value: t })}
                                    style={{
                                        flex: 1,
                                        padding: '12px 0',
                                        fontWeight: 700,
                                        fontSize: '15px',
                                        borderRadius: '10px',
                                        border: `2px solid ${selected ? '#1a1a2e' : showErrors && formErrors.title ? '#e53935' : '#1a1a2e'}`,
                                        background: selected ? '#1a1a2e' : '#fff',
                                        color: selected ? '#fff' : '#1a1a2e',
                                        cursor: 'pointer',
                                        transition: 'all 0.15s ease',
                                    }}
                                >
                                    {t}
                                </button>
                            )
                        })}
                    </div>
                </Field>
                <div className={`${globalStyles.nameFields} ${globalStyles.nameFields}`}>
                    <Field
                        fieldLabel="First Name"
                        labelPosition="left"
                        extraStyle={{ flex: 1, margin: '0 0 20px' }}
                        enhanced={true}
                    >
                        <InputFieldText
                            fieldName="firstname"
                            saveValue={preSaveValueFunct}
                            populateValue={stepData.firstname || ''}
                            enhanced={true}
                            required={true}
                            showErrors={showErrors}
                        />
                    </Field>
                    <Field
                        fieldLabel="Last Name"
                        labelPosition="left"
                        extraStyle={{ flex: 1, margin: '0 0 20px' }}
                        enhanced={true}
                    >
                        <InputFieldText
                            fieldName="lastname"
                            saveValue={preSaveValueFunct}
                            populateValue={stepData.lastname || ''}
                            enhanced={true}
                            required={true}
                            showErrors={showErrors}
                        />
                    </Field>
                </div>
                <Field fieldLabel="Date of Birth" labelPosition="left" enhanced={true}>
                    <InputFieldDate
                        fieldName="dob"
                        saveValue={preSaveValueFunct}
                        populateValue={stepData.dob || ''}
                        enhanced={true}
                        required={true}
                        showErrors={showErrors}
                    />
                </Field>
                <SubmitButton text="Continue" btnType="primary" onClick={handleNext} disabled={!isFormValid} />
                <div style={{ marginTop: '16px', padding: '14px 16px', background: '#eef7fc', borderRadius: '10px', border: '1px solid #c8e6f5' }}>
                    <p style={{ margin: '0 0 4px', fontWeight: 700, fontSize: '14px', color: '#1a1a2e' }}>Why we need this?</p>
                    <p style={{ margin: 0, fontSize: '13px', color: '#555', lineHeight: '1.5' }}>We use your personal details to verify your identity and check for any finance agreements in your name.</p>
                </div>
                <hr style={{ border: 'none', borderTop: '1px solid #e0e0e0', margin: '20px 0' }} />
                <p style={{ margin: '0', fontSize: '13px', color: '#777', textAlign: 'center', lineHeight: '1.5' }}>
                    We will not pressure you into making a decision. You are free to take time, ask questions,
                    complain directly, use any free route available, or instruct another representative.
                </p>
                <p style={{ margin: '8px 0 0', fontSize: '13px', color: '#777', textAlign: 'center', lineHeight: '1.5' }}>
                    Submitting an enquiry does not guarantee that you have a valid claim, that Sentinel Legal Ltd
                    will accept your matter, or that any compensation will be recovered. Any assessment will depend
                    on the facts, documents, lender response, applicable law and any relevant regulatory scheme.
                </p>
            </FormCard>
        </FieldGroup>
    ) : (
        <></>
    )
}
